import * as actions from "./actions";

let initialState = {
  fetching: false,
  fetched: false,
  error: null,
  data: {},
  holdings: {},
  transfer: {
    sent: false,
    sending: false,
    error: null,
  },
};

const depot = (state = initialState, action) => {
  switch (action.type) {
    case actions.DEPOT_FETCH_REQUEST:
      return Object.assign({}, state, {
        fetching: true,
        error: null,
      });
    case actions.DEPOT_FETCH_SUCCESS: {
      let data = Array.isArray(action.response)
        ? action.response
        : [action.response];
      return Object.assign({}, state, {
        fetching: false,
        fetched: true,
        error: null,
        data: Object.assign({}, state.data, {
          [action.additionalData]: data,
        }),
      });
    }
    case actions.DEPOT_FETCH_ERROR:
      return Object.assign({}, state, {
        fetching: false,
        error: action.error,
      });

    // Transfering amount to savelend account
    case actions.TRANSFER_TO_SAVELEND_ACCOUNT_REQUEST:
      return Object.assign({}, state, {
        transfer: Object.assign({}, state.transfer, {
          sent: false,
          sending: false,
          error: null,
        }),
      });
    case actions.TRANSFER_TO_SAVELEND_ACCOUNT_SUCCESS:
      return Object.assign({}, state, {
        transfer: Object.assign({}, state.transfer, {
          sent: true,
          sending: false,
          error: null,
        }),
      });
    case actions.TRANSFER_TO_SAVELEND_ACCOUNT_ERROR:
      return Object.assign({}, state, {
        transfer: Object.assign({}, state.transfer, {
          sent: false,
          sending: false,
          error: action.error,
        }),
      });

    case actions.GET_HOLDINGS_FOR_DERPOD_REQUEST:
      return Object.assign({}, state, {
        holdings: Object.assign({}, state.holdings, {
          [action.additionalData]: {
            fetching: true,
            fetched: false,
          },
        }),
      });

    case actions.GET_HOLDINGS_FOR_DERPOD_SUCCESS:
      return Object.assign({}, state, {
        holdings: Object.assign({}, state.holdings, {
          [action.additionalData]: {
            fetching: false,
            fetched: true,
            data: action.response,
          },
        }),
      });

    case actions.GET_HOLDINGS_FOR_DERPOD_ERROR:
      return Object.assign({}, state, {
        holdings: Object.assign({}, state.holdings, {
          [action.additionalData]: {
            fetching: false,
            fetched: false,
            error: action.error || action.response,
          },
        }),
      });
    default:
      return state;
  }
};

export default depot;
